import { Box, Typography } from "@braintrust/braintrust-ui-components";

import styles from "./styles.module.scss";

type SetWorkAvailabilityProps = {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
};

export const SetWorkAvailability = ({ onClick }: SetWorkAvailabilityProps) => {
  return (
    <Box className={styles.workAvailability} onClick={onClick}>
      <Typography component="span" size="small" fontWeight={500} color="grey-1">
        Set work availability
      </Typography>
    </Box>
  );
};
